import styled from "styled-components";

import backgroudImage from "../../assets/imgs/background.png";

export const StyledModal = styled.div`
	position: fixed;
	top: 0;
	left: 0;

	z-index: 99;

	width: 100%;
	height: 100%;

	padding-top: 6rem;

	background-color: #33333355;

	@keyframes ModalAppear {
		0% {
			opacity: 0;
			transform: translateY(-20px);
		}
		100% {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.modal {
		margin: 0 auto;
		padding: 20px;

		width: fit-content;
		max-width: 600px;
		height: fit-content;

		color: white;
		background: url(${backgroudImage}), var(--color-gray-1);
		background-repeat: repeat;
		box-shadow: 0 0 5px var(--color-gray-300);
		border-radius: var(--radius);

		animation: ModalAppear 0.3s ease;

		@media screen and (max-width: 460px) {
			max-width: 370px;
			padding: 15px 10px;
		}

		.modal-header {
			width: 100%;
			display: flex;
			justify-content: space-between;

			.close {
				margin-left: auto;
				width: 2.3rem;

				cursor: pointer;

				img {
					width: 100%;
					/* filter: drop-shadow(1px 0 5px var(--color-gray-3)); */
					transition: all 0.3s ease;

					&:hover {
						scale: 1.01;
						filter: drop-shadow(2px 0 5px var(--color-gray-7));
					}
				}
			}
		}
	}
`;
